import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateUserRole,
    deleteUserRole,
    getListUserRoles,
    getPageUserRoles,
} from '../UserRoleEndPoint'

export const useListUserRoles = (
    requestorId,
    simple,
    rows,
    filterRequest,
    enabled = true,
) => {
    const {userRoleKeys} = QueryKeyManager(QueryKeyTypes.userRole, requestorId)

    return useQuery({
        queryKey: userRoleKeys.list({
            simple,
            rows,
            filterRequest,
        }),
        queryFn: () =>
            getListUserRoles(requestorId, rows, simple, filterRequest),
        enabled: !!requestorId && !!enabled,
    })
}

export const usePageUserRoles = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {userRoleKeys} = QueryKeyManager(QueryKeyTypes.userRole, requestorId)

    return useQuery({
        queryKey: userRoleKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageUserRoles(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useUserRoleCRUD = (type, requestorId) => {
    const {userRoleKeys} = QueryKeyManager(QueryKeyTypes.userRole, requestorId)
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateUserRole(requestorId, data)
                : type === QueryCRUDTypes.delete
                ? deleteUserRole(requestorId, data?.id)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'User Role Update Successfully !!',
                    )
                } else if (type === QueryCRUDTypes.delete) {
                    showNotification(
                        severityNotification.success,
                        'Deletion performed successfully!!',
                    )
                }
            }
        },
    })
}
